import axios from 'axios';
import { IConstante } from '../../types/interfaces';
import { tokenConfig } from './authActions';
import store from '../store';

export const getConstanteByID = async (id: number) : Promise<IConstante | boolean> => {
  return new Promise((resolve) => {
  axios
    .get('/api/constantes/specific', {...tokenConfig(store.getState), params: {id}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => {
      resolve(false);
      console.log("err getConstanteByID", err)
      // dispatch(returnErrors(err.response.data, err.response.status))
    });
  });
};

export const getConstanteProjetInfos = async (projectId: number, projectName: string) : Promise<IConstante | boolean> => {
  return new Promise((resolve) => {
  axios
    .get('/api/constantes/projet', {...tokenConfig(store.getState), params: {projectId, projectName}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => {
      resolve(false);
      console.log("err getConstanteByID", err)
      // dispatch(returnErrors(err.response.data, err.response.status))
    });
  });
};

export const getConstanteRecuImageIncrem = async (): Promise<number> => {
  return new Promise((resolve) => {
  axios
    .post('/api/constantes/recu_image', tokenConfig(store.getState))
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      console.log("err getConstanteRecuImageIncrem", err)
    });
  });
};
